$(document).ready(function()
{

    let categoryFilterValue = '';
    let monthFilterValue = '';

    $( ".stay-on-events-page-dropdown-menu a" ).click(function(e) 
    {
        e.preventDefault();
        let filterValue = $(this).data("filter-value");
        let text = $(this).text();
        let label = "#"  + $(this).data('labelled');
        $(label).html(text);
        if ($(this).data('labelled') == 'filterDropdown')
        {
            categoryFilterValue = filterValue;
        }
        if ($(this).data('labelled') == 'filterMonthDropdown')
        {
            monthFilterValue = filterValue;
        }

        closeAll();

        setTimeout( 
            function() 
            { 
                applyBothFilters();
            }, 300
        );
    });


    function applyBothFilters()
    {
        current_count = 0;

        $('.event-listing-section .event-filter-card').each(function(i, obj)
        {
            let category = $(this).data('category');
            let month = $(this).data('month');

            if ( (monthFilterValue == 'all' || monthFilterValue == '' || monthFilterValue == month) && (categoryFilterValue == 'all' || categoryFilterValue == '' || category.includes(categoryFilterValue)) )
            {
                $(this).fadeIn(300); 
                $(this).parents('.event-listing-section').fadeIn(300);
                current_count++;
            }
        });          
        $('#page-counter-results').text(current_count + " event" + ( (current_count != 1) ? "s" : ''  ));

        if ( current_count > 0)
        {
            $("#noMatchingEvents").removeClass("active");  
        }
        else
        {
            $("#noMatchingEvents").addClass("active");
        }
    }

    function closeAll()
    {
        // fade out cards
        $('.event-listing-section .event-filter-card').each(function(i, obj)
        {
            $(this).fadeOut(300);
        });
        // fade out month containers
        $('.event-listing-section').each(function(i, obj)
        {
            $(this).fadeOut(300);
        });

    }

});